import { render, staticRenderFns } from "./NewSuppliedGoodForm.vue?vue&type=template&id=27b5fea8&scoped=true&"
import script from "./NewSuppliedGoodForm.vue?vue&type=script&lang=js&"
export * from "./NewSuppliedGoodForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b5fea8",
  null
  
)

export default component.exports